<template>
  <b-field
    :label="label"
    class="field--contents-inline field--calcNumber"
    :class="classNames"
  >
    <app-number-input
      class="input"
      :value="value"
      :step="step"
      :placeholder="placeholder"
      :precision="precision"
      :min="min"
      :max="max"
      :disabled="disabled"
      v-on="listeners"
    />

    <p class="control" v-if="addon">
      <span class="button is-static">{{ addon }}</span>
    </p>
  </b-field>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: undefined,
    },
    value: {
      type: Number,
      required: true,
    },

    addon: {
      type: String,
    },

    addonPosition: {
      default: "right",
      validator: (val) => ["left", "right"].includes(val),
    },

    precision: {
      type: Number,
      default: 2,
    },

    min: {
      type: Number,
      default: 0,
    },

    max: {
      type: Number,
      default: 100,
    },

    step: {
      type: Number,
      default: 1,
    },

    placeholder: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classNames() {
      return [
        this.addon !== undefined
          ? `field--has-addon field--addon_position--${this.addonPosition}`
          : "",
      ];
    },
    listeners() {
      const vm = this;

      return {
        ...this.$listeners,

        input(value) {
          vm.$emit("input", value);
        },
      };
    },
  },
};
</script>
